import { render, staticRenderFns } from "./DictionaryToolbar.vue?vue&type=template&id=4ef046f1"
import script from "./DictionaryToolbar.vue?vue&type=script&lang=js"
export * from "./DictionaryToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports